import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { hideModal } from "../../../redux/modules/Modal"
import BaseModalVoucherBundle from "./BaseModalVoucherBundle"

class VoucherBundleModal extends Component {
	constructor(props) {
		super(props)

		this.handleCloseClick = this.handleCloseClick.bind(this)
	}

	handleCloseClick() {
		const { hideModal, onCloseClick } = this.props
		onCloseClick && onCloseClick()
		hideModal()
	}

	render() {
		return (
			<BaseModalVoucherBundle
				{...this.props}
				onConfirmClick={this.handleCloseClick}
				onCancelClick={this.handleCloseClick}
				message={this.props.message}
			/>
		)
	}
}
VoucherBundleModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	hideModal: PropTypes.func.isRequired,
	message: PropTypes.object.isRequired,
	title: PropTypes.string,
	onCloseClick: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
})

export default connect(null, mapDispatchToProps)(VoucherBundleModal)



// WEBPACK FOOTER //
// ./src/views/components/modal/VoucherBundleModal.js